module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAA8CAMAAAAnktjvAAAANlBMVEUAAACampqZmZmampqoqKiZmZmZmZmampqampqZmZmZmZmdnZ2enp6ampqcnJybm5uZmZmZmZmQ0pAAAAAAEXRSTlMA9OdkDNrLu5J7UCIVpz0uWuaPjscAAAB+SURBVEjH7dTJDcAgDETRsO8Q999snA6+FEXiwJzfARjj6+RkrzRrK6RORByjPqgtzPaoNjPrk9pxsQy1yTOb1cbObFEbGn8zu5itRsRMZudrYXHL8uLan8XdHyg4ALgWfSxeAS+WjwsfQj7a/MPwb8gr4iuDLyK+3k5Ots0DUnQIAawZHW8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/address_more.png
// module id = 487
// module chunks = 38